import React from 'react';
import './Button.css';

const Button = ({ className, type, text, onClick, disabled, children }) => {
  return (
    <button type={type} className={`custom-button ${className} ${disabled ? "disabled-button" : "" }`} onClick={onClick} disabled={disabled}>
       {children}
      <span className="button-text">{text}</span>
    </button>
  );
};

export default Button;
